//
import Model from "@/models/Model"

//
import RawQueryModel from "@/models/Actions/ARawQuery"
import RunModel from "@/models/Actions/ARun"

/**
 * @class
 */
export default class GQuery extends Model {

    /**
     * @description
     */
    get run_url () {
        return this.resource().concat( "/" ).concat( this.id ).concat( "/run" )
    }
    
    /**
     * 
     */
    rawQuery ( rawQuery = "" ) {
        return this.hasMany( RawQueryModel ).params({ raw_query: String( rawQuery ) })
    }

    /**
     * @description
     */
    resource() {
        return "g_query"
    }

    /**
     * 
     */
    run () {
        return this.hasMany( RunModel )
    }

    /**
     * @description
     */
    toCreate () {
        return this.clean([
            "name",
            "query",
        ])
    }
    
    /**
     * @description
     */
    toRun () {

        //
        let clone = this.clean([ "id" ])

        clone.constructor.constructor.resource = () => {
            return clone.run_url
        }

        //
        console.log( clone.constructor.constructor )
        console.log( clone.constructor.constructor.resource() )

        //
        return clone.constructor
    }

    /**
     * @description
     */
    toUpdate () {
        return this.clean([
            "id",
            "name",
            "query",
        ])
    }
}